import { useQuery } from '@tanstack/react-query'
import { getRules } from 'api/wage/getRules'
import { wageRuleKeys } from './keys'

export const useRulesQuery = (request: Parameters<typeof getRules>[0] = {}) => {
  return useQuery({
    queryKey: wageRuleKeys.list([request.jurisdictionId]),
    queryFn: () => getRules(request),
  })
}
